import { CoreParameterModel } from '../models';
import { ILocalSearchParameter } from '@fi-shared/models/models';
import { FileType, SideListOptionType } from '@fi-shared/types';

export class MediaBankListParameter extends CoreParameterModel implements ILocalSearchParameter {
    TagIds: number[];
    CreatedByUserNames: string[];
    ContentSearchTexts: string[];
    BusinessAreaIds: number[];
    FilterTypes: SideListOptionType[];
    FileTypes: FileType[];
}
